import { isUndefined, isNull } from 'lodash'
import { DeviceLinkModel } from '../../models'
import { PairingState } from '../../types'
import { DeviceLinksDto } from '../dto'

const isNullOrUndefined = (value: unknown): boolean => isNull(value) || isUndefined(value)

const deviceLinksDtoToModelTransformer = (values: DeviceLinksDto): DeviceLinkModel[] => {
  return values.id.map((id, index) => ({
    deviceType: values.deviceType[index],
    installationId: values.installationId[index] || -1,
    createdAt: values.createdAt[index] || '',
    deletedAt: values.deletedAt[index] || '',
    deviceId: !isNullOrUndefined(values.deviceId[index]) ? String(values.deviceId[index]) : '',
    deviceShortUuid: !isNullOrUndefined(values.deviceShortUuid[index]) ? String(values.deviceShortUuid[index]) : '',
    deviceUuid: !isNullOrUndefined(values.deviceUuid[index]) ? String(values.deviceUuid[index]) : '',
    id: !isNullOrUndefined(id) ? Number(id) : -1,
    nextDeviceLinkId: !isNullOrUndefined(values.nextDeviceLinkId[index]) ? Number(values.nextDeviceLinkId[index]) : -1,
    pairingState: values.pairingState[index] || PairingState.NotRequired,
    previousDeviceLinkId: !isNullOrUndefined(values.prevDeviceLinkId[index]) ? Number(values.prevDeviceLinkId[index]) : -1,
    startAt: values.startAt[index] || '',
    stopAt: values.stopAt[index] || '',
    updatedAt: values.updatedAt[index] || '',
    decommissionedAt: values.decommissionedAt[index] || '',
    productName: values.productName[index] || undefined,
    deviceName: values.deviceName[index] || '',
    installedBy: values.installedBy[index] || 0,
    ownerFullName: values?.ownerFullName?.[index] ?? undefined,
    ownerId: values?.ownerId?.[index] ?? undefined,
    ibnDeadlineAt: values?.ibnDeadlineAt?.[index] ?? undefined,
    installationRequirements: values?.installationRequirements?.[index] ?? undefined,
  }))
}

export default deviceLinksDtoToModelTransformer
